import { Paper } from '@mui/material';
import { withGlobalSearchParams } from 'apps/app/src/components/utility/GlobalSearchParamsBoundary';
import { useReportSummaries } from 'apps/app/src/hooks/requests/use-report-summaries';
import { isNotProduction } from 'apps/app/src/utils/env-indicator';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { withPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { ReportsPageContent } from './reports-page-components/ReportsPageContent';
import { ReportTabsCarousel } from './reports-page-components/ReportTabsCarousel';

const ReportsPage: React.FC = () => {
  const reportSummaries = useReportSummaries();

  return (
    <>
      <Helmet>
        <title>Reports</title>
      </Helmet>
      
      <ReportTabsCarousel reportSummaries={reportSummaries}/>
      
      <Paper
        variant="outlined"
        sx={theme => ({
          borderRadius: '12px',
          top: '20px',
          boxShadow: theme.shadows[1],
          height: 'calc(100% - 72px)',
          overflow: 'hidden',
          position: 'relative',
        })}
      >
        <ReportsPageContent />
      </Paper>
    </>
  );
};

const ReportsPageWithSuspenseBoundary = withPageLayout(withGlobalSearchParams(ReportsPage), {
  path: ['Reports', 'Reports List'],
  title: 'Reports',
  action: isNotProduction()
    ? (
      <Link
        className='text-blue-600 underline hover:text-blue-800'
        to="admin"
      >
        Admin
      </Link>
    )
    : <></>,
});

export { ReportsPageWithSuspenseBoundary as ReportsPage };